import axios from 'axios'
import { config } from '../utils/config'
import { apiErrorHandler } from './apiErrorHandler'
import { loadProgressBar } from 'axios-progress-bar'
import { saveAs } from 'file-saver';

const axiosWithProgress = axios.create()
const axiosWithoutProgress = axios.create()

loadProgressBar({}, axiosWithProgress)

export const BaseUrl = {
    Api: config.apiBaseUrl,
    Identity: config.identityBaseUrl,
    Centerpoint: config.centerpointBaseUrl,
}

export function setAuthHeader(token) {
    axiosWithProgress.defaults.headers.common['Authorization'] = token ? 'Bearer ' + token : ''
    axiosWithoutProgress.defaults.headers.common['Authorization'] = token ? 'Bearer ' + token : ''
}

/**
 * @param {string} path 
 * @param {string} baseUrl 
 * @param {ApiOptions} options  
 */
export const get = async (path, baseUrl = BaseUrl.Api, options = null) => {
    const axiosParams = options?.axiosParams || {}
    try {
        const result = await axiosInstance(options?.hideProgressBar)({
            method: "get",
            url: `${baseUrl}/${path}`,
            ...axiosParams
        })
        return result.data
    }
    catch (err) {
        await apiErrorHandler(err, options?.statusCodeHandlers)
    }
}

/**
 * @param {string} path 
 * @param {object} data 
 * @param {ApiOptions} options 
 * @param {string} baseUrl 
 * @returns 
 */
export const put = async (path, baseUrl = BaseUrl.Api, data, options = null) => {
    const axiosParams = options?.axiosParams || {}
    try {
        const result = await axiosInstance(options?.hideProgressBar)({
            method: "put",
            url: `${baseUrl}/${path}`,
            data,
            ...axiosParams
        })
        return result.data
    }
    catch (err) {
        await apiErrorHandler(err, options?.statusCodeHandlers)
    }
}

/**
 * @param {string} path 
 * @param {Object} data 
 * @param {ApiOptions} options 
 * @param {string} baseUrl 
 * @returns 
 */
export const post = async (path, baseUrl = BaseUrl.Api, data, options = null) => {
    const axiosParams = options?.axiosParams || {}
    try {
        const result = await axiosInstance(options?.hideProgressBar)({
            method: "post",
            url: `${baseUrl}/${path}`,
            data,
            ...axiosParams
        })
        return result.data
    }
    catch (err) {
        await apiErrorHandler(err, options?.statusCodeHandlers)
    }
}

/** 
 * @param {string} path 
 * @param {ApiOptions} options 
 * @param {string} baseUrl 
 * @returns 
 */
export const destroy = async (path, baseUrl = BaseUrl.Api, options = null) => {
    const axiosParams = options?.axiosParams || {}
    try {
        const result = await axiosInstance(options?.hideProgressBar)({
            method: "delete",
            url: `${baseUrl}/${path}`,
            ...axiosParams
        })
        return result.data
    }
    catch (err) {
        await apiErrorHandler(err, options?.statusCodeHandlers)
    }
}

/** 
 * @param {string} path 
 * @param {string} filename 
 * @param {string} baseUrl 
 * @param {ApiOptions} options 
 */
export const download = async (path, baseUrl = BaseUrl.Api, data, fileName, options = null) => {
    const axiosParams = options?.axiosParams || {}
    try {
        const result = await axiosInstance(options?.hideProgressBar)({
            method: "post",
            url: `${baseUrl}/${path}`,
            data,
            responseType: 'blob', // important
            ...axiosParams
        })

        saveAs(result.data, fileName);
    }
    catch (err) {
        await apiErrorHandler(err, options?.statusCodeHandlers)
    }
}

const axiosInstance = (hideProgressBar) => {
    if (hideProgressBar === true) {
        return axiosWithoutProgress
    }
    return axiosWithProgress
}